// Theory Tabs web component

if (!customElements.get("td-tabs")) {
  class TabComponent extends HTMLElement {
      constructor() {
          super();
      }
  
      connectedCallback() {
        setTimeout(() => {
          this.setupEventListeners();
        }, 0);
      }
  
      setupEventListeners() {
          let tabs = this.querySelectorAll(`.td-tabs__tab`);
          let buttons = this.querySelectorAll(`.td-tabs__selector`);
          let showAllButton = this.querySelector(`.td-tabs__show-all`);
          let ctas = this.querySelectorAll(`.td-tabs__cta`);
      
          // Tab selector buttons
          buttons.forEach((button) => {
              button.addEventListener("click", () => {
                  // Grab the IDs that will identify matching tabs & buttons  
                  let tabId = button.dataset.tab;
                  let buttonId = button.dataset.button;
                  let ctaId = button.dataset.cta;
              
                  // Loop through the tab elements
                  // If the ID matches set it as active, otherwise remove the active class
                  tabs.forEach(tab => {
                      if (tab.id == tabId) {
                          tab.classList.add('active');
                      } else {
                          tab.classList.remove('active');
                      }
                  });
              
                  // Loop through the button elements
                  buttons.forEach(button => {
                      if (button.id == buttonId) {
                          button.classList.add('active');
                      } else {
                          button.classList.remove('active');
                      }
                  });
              
                  // Loop through the ctas
                  ctas.forEach(cta => {
                      if (cta.id == ctaId) {
                          cta.classList.add('active');
                      } else {
                          cta.classList.remove('active');
                      }
                  });
                  
                  // Remove active class from show all button
                  if (showAllButton != null){
                    showAllButton.classList.remove('active');
                  } 
              });
          });

          // Show all button
          if (showAllButton != null){
            showAllButton.addEventListener("click", () => {
              // Show all tabs
              tabs.forEach(tab => {
                  tab.classList.add('active')
              });

              // Show all ctas
              ctas.forEach(cta => {
                cta.classList.add('active');
              });
            
              // Remove selector active class
              buttons.forEach(button => {
                  button.classList.remove('active')
              });
            
              // Add active class to show all
              showAllButton.classList.add('active');
            });
          }
      }
  }
  
  customElements.define('td-tabs', TabComponent);
}